export default __webpack_public_path__ + "images/39_2_image.jpg";